import React, { useState } from 'react'
import { StatusInputWrapper } from './StatusInputWrapper'

const FieldInput = ({ t, label, value, changeObjectPropertyAction, validate, errorMsg, isValid, setIsError, ...statusInputProps }) => {
  // const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const handleChange = (e) => {
    try {
      let name = e.currentTarget.value
      changeObjectPropertyAction(name)
      // validate(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlur = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      changeObjectPropertyAction(name, true)

      validate(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <StatusInputWrapper
      isValid={isValid}
      errorMsg={errorMsg}
      onChange={handleChange}
      // onBlur={onBlur}
      onFocus={() => SetIsFocussed(true)}
      value={value}
      t={t}
      label={label}
      isFocussed={isFocussed}
      {...statusInputProps}
    />
  )
}

export default FieldInput
